<template>
  <div :class="[showBtn,showBtnWhenNotEmpty?'':'show-btn']">
    <el-upload
        :class="(readonlyShowPic?'readonlyShowPic ':' ')+(readonly?'readonly ':' ')"
        :action="uploadUrl"
        :with-credentials="true"
        :show-file-list="showFileList"
        :file-list="fileList"
        ref="lzUpload"
        :on-remove="removeFile"
        :on-progress="onProgress"
        :on-error="onError"
        :multiple="multiple"
        :on-change="handleChange"
        :auto-upload="!multiple"
        :limit="limit"
        :on-exceed="onExceed"
        :on-success="uploadSuccess">
      <el-button :type="buttonType" :size="size">{{ caption }}</el-button>
      <div slot="tip" class="el-upload__tip">{{ tips }}</div>
      <div slot="file" slot-scope="{file}" class="df jsb ac">
        <span class="button" @click="onlinePreview(file)">{{ file.name }}</span>
        <span>
          <i class="el-icon-download icon-button" @click="()=>download(file)"></i>
          <i class="el-icon-error icon-button" v-if="!readonly" @click="()=>handleRemoveFile(file)"></i>
        </span>
      </div>
    </el-upload>
    <!--  下面这部分是用来展示照片用的  -->
    <div class="df fw" v-if="alwaysShowPic || (readonlyShowPic && readonly && fileList)">
      <div class="lz-photo" v-for="(item,index) in fileList">
        <img :src="item.url" :key="item.url">
        <div class="mask">
          <el-popover width="600" trigger="click">
            <img :src="item.url" class="wpt100" :key="item.url" @click.prevent>
            <template slot="reference">
              <i class="el-icon-zoom-in"></i>
            </template>
          </el-popover>
          <i class="el-icon-delete hide-if-view" @click="deleteFile($event,item)"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {onlinePreviewUrl, rootUrl} from "@/config";
import util from "@/common/js/util";
import axios from "axios";

export default {
  name: "lzUpload",
  props: {
    fileList: {
      required:false,
      default(){
        return [];
      }
    },
    size: util.prop(false, "small"),
    caption: util.prop(false, '选择文件'),
    buttonType: util.prop(false, 'primary'),
    showBtnWhenNotEmpty: util.prop(false, true),
    tips: util.prop(false, ''),
    multiple: util.prop(false, false),
    limit: util.prop(false, 1),
    readonly: util.prop(false, false),
    readonlyShowPic: util.prop(false, false),
    alwaysShowPic: util.prop(false, false),
    showFileList: util.prop(false, true),
  },
  watch:{
    fileList: {
      handler:function (newVal) {
        this.fileListInner = newVal;
      },
      immediate: true
    }
  },
  computed: {
    showBtn: function () {
      if (this.fileListInner && this.fileListInner.length > 0) {
        if (!this.showBtnWhenNotEmpty) {
          return 'no-btn'
        }
      }
      return 'has-btn';
    }
  },
  data() {
    return {
      uploadUrl: `${rootUrl}file/upload`,
      showError: false,
      // showBtn: true,
      multipleInner: false,
      fileListInner: this.fileList,
    }
  },
  mounted() {
  },
  methods: {
    handleRemoveFile(file){
      this.$confirm('确认删除？')
          .then(_ => {
            this.fileList.splice(this.fileList.indexOf(file), 1);
            this.removeFile(file, this.fileList);
          }).catch(_ => {});
    },
    download(f) {
      util.downloadByLink(f.url, f.name);
    },
    deleteFile(event, file) {
      this.$confirm('确认删除？')
          .then(_ => {
            this.fileList.splice(this.fileList.indexOf(file),1)
          }).catch(_ => {});
    },
    onlinePreview(f){
      util.onlinePreview({previewServerUrl:onlinePreviewUrl, previewFileurl:f.url})
    },
    onProgress(){
      this.$root.uploading = true;
    },
    onError(){
      this.$root.uploading = null
    },
    removeFile(file, fileList) {
      this.$emit("update:fileList", fileList);
      this.$parent.$emit("el.form.change", fileList);
      this.fileListInner = fileList;
      this.$emit("change")
    },
    onExceed() {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件`);
    },
    handleChange(file, fileList) {
      if (!this.multiple) return;
      let length = fileList.length;
      this.maxLength = Math.max(length, this.maxLength||0);
      window.setTimeout(() => {
        if (length === this.maxLength) {
          Promise.all(fileList.filter(item => item.status === 'ready').map(item=>this.submitUpload(item))).then((d) => {
            this.maxLength = 0;
            this.$emit("update:fileList", this.fileListInner);
            this.$parent.$emit("el.form.change", this.fileListInner);
            this.$emit("change", this.fileListInner);
          }).catch(()=>{
            this.maxLength = 0;
          });
        }
      }, 100);
    },
    // 上传到服务器
    async submitUpload(file) {
      const formData = new FormData() // new formData对象
      formData.append('file', file.raw);
      // 这里不使用this.axios，因为this.axios里有对数据转换的逻辑
      this.$root.uploading = true;
      try{
        let res = await axios({
          url:     this.uploadUrl,
          method:  'post',
          data:    formData,
          withCredentials: true,
          headers: {"Content-Type": "multipart/form-data"},
        });
        this.uploadSuccess(res.data, file, false);
        return res;
      }finally {
        if (this.$root.uploading) {
          this.$root.uploading = null;
        }
      }
    },
    uploadSuccess(res, file, emitChange=true) {
      let index = this.fileListInner.indexOf(file);
      let f = {
        url: res.module.url,
        name: file.name,
        type: res.module.type,
        uid:util.incr()
      }
      if (index > -1) {
        this.fileListInner.splice(index, 1, f);
      }else{
        this.fileListInner.push(f);
      }
      if (emitChange) {
        this.$emit("update:fileList", this.fileListInner);
        this.$parent.$emit("el.form.change", this.fileListInner);
        this.$emit("change", this.fileListInner);
        this.$root.uploading = null;
      }
    }
  }
}
</script>
<style lang="scss">
.el-icon-close-tip {
  display: none;
}

.img-preview {
  width: 100px;
  height: 100px;
}

.readonlyShowPic.readonly {
  .el-upload-list {
    display: none;
  }
}

.readonly:not(.readonlyShowPic) {
  .el-upload, .el-upload-list__item-status-label, .el-icon-close, .el-icon-close-tip {
    display: none;
  }

  .el-upload-list__item-name:hover {
    cursor: default;
    color: #606266;
  }
}

.lz-photo {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  margin: 10px;
  box-shadow: 2px 2px 2px #bebebe;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 2;
    background-color: #0000005c;
    display: none;
    align-items: center;
    justify-content: center;

    i {
      font-size: 20px;
      color: white;
      margin: 4px;
      cursor: pointer;
    }
  }

  &:hover .mask {
    display: flex;
  }
}

.no-btn {
  .el-upload.el-upload--text {
    display: none;
  }
}
.has-btn.show-btn{
  position: relative;
  top: 4px
}
.el-table__cell .el-upload-list.el-upload-list--text .el-upload-list__item>.el-upload-list__item-name{
    word-break: break-all;
    white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/index.vue